/// <amd-module name="Core/Medius.Core.Web/Scripts/AdminPages/AuthorizationGroups/Tabs/companyAutocompleter/companyAutocompleter"/>
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent, ComboBoxOpenEvent } from "@progress/kendo-react-dropdowns";
import * as React from "react";

export interface ICompanyAutocompleterProps<T> {
    required: boolean;
    disabled?: boolean;
    label: string;
    textFieldSelector: string;
    selectedItem: T;
    loadedCompanies: T[];
    onCompanyChange: (company: T) => void;
    onFilterChange: (filter: string) => void;
    onDropdownOpen: (event: ComboBoxOpenEvent) => void;
}

export function CompanyAutocompleter<T>(props: ICompanyAutocompleterProps<T>) {
    const { required, label, textFieldSelector, selectedItem, loadedCompanies, onCompanyChange, onFilterChange, onDropdownOpen, disabled = false } = props;

    const handleCompanyChange = (event: ComboBoxChangeEvent) =>
        onCompanyChange(event.value);

    const handleFilterChange = (event: ComboBoxFilterChangeEvent) => {
        const filter = event.filter.value;
        onFilterChange(filter);
    };

    const handleCompanyDropdownOpen = (event: ComboBoxOpenEvent) =>
        onDropdownOpen(event);

    return (
        <ComboBox
            data-testid="company-autocompleter"
            label={label}
            filterable
            required={required}
            data={loadedCompanies}
            value={selectedItem}
            textField={textFieldSelector}
            disabled={disabled}
            onFilterChange={handleFilterChange}
            onChange={handleCompanyChange}
            onOpen={handleCompanyDropdownOpen}
        />
    );
}
